var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSectionOneNewBoxBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 216,
    viewBox: "0 0 600 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9461_5753",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 600,
    height: 216
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 84C0 37.6081 37.6081 0 84 0H301.008H516C562.392 0 600 37.6081 600 84V216H0V84Z",
    fill: "url(#paint0_linear_9461_5753)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9461_5753)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 84C0 37.6081 37.6081 0 84 0H301.008H516C562.392 0 600 37.6081 600 84V216H0V84Z",
    fill: "url(#paint1_linear_9461_5753)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.024 15.2396C487.13 66.5659 507.522 118.342 531.874 166.997C533.431 170.132 531.7 173.901 528.304 174.7C479.772 185.696 433.839 217.544 398.944 253.62C396.289 256.363 391.683 255.52 390.144 252.002C378.631 224.976 318.615 87.6186 318.391 87.1056C317.578 85.2697 317.848 83.0837 319.112 81.5118C354.265 38.2603 409.074 12.1761 463.905 11.6089C466.204 11.6095 468.257 13.0725 469.024 15.2396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("path", {
    d: "M469.023 15.2402C487.13 66.5666 507.521 118.342 531.874 166.998C533.431 170.133 531.7 173.902 528.304 174.701C479.771 185.697 433.839 217.544 398.944 253.62C396.288 256.364 391.682 255.52 390.143 252.002C389.749 251.077 389.315 250.142 388.921 249.217C393.849 237.424 402.789 207.025 406.196 194.747C430.6 107.227 434.378 44.4405 437.797 13.8305C446.402 12.4467 455.135 11.7003 463.904 11.6096C466.203 11.6102 468.257 13.0732 469.023 15.2402Z",
    fill: "#F7F7FA"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M547.162 220.899C547.784 222.23 545.765 223.795 544.538 222.958L518.764 205.035C517.755 204.321 516.068 205.131 515.992 206.406C515.216 216.883 510.213 227.138 504.764 236.866C503.981 238.296 501.79 238.157 501.677 236.699C500.202 215.646 495.054 195.661 486.991 176.428L515.309 163.809C523.16 175.538 536.713 198.636 547.162 220.899Z",
    fill: "#181A49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.295 174.952C520.314 179.739 517.349 184.167 513.763 187.945C510.111 191.819 502.536 199.05 495.671 201.519C493.614 193.996 491.084 186.464 488.038 178.939C498.282 176.564 508.031 171.97 516.41 165.571C518.441 168.71 520.411 171.81 522.295 174.952Z",
    fill: "#030422"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.056 137.065C529.31 150.99 526.353 169.11 513.842 178.026C501.38 186.907 483.381 183.838 473.217 170.715C462.611 157.022 464.479 137.642 477.865 127.941C491.309 118.198 510.396 122.529 520.056 137.065Z",
    fill: "#EE85F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.679 179.664C500.368 187.032 486.257 186.223 475.943 178.328C459.654 166.072 458.326 141.413 474.423 129.711C487.9 119.944 507.057 124.38 516.755 138.781C526.088 152.688 523.193 170.756 510.679 179.664Z",
    fill: "#FCD6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.757 143.488C516.254 152.948 514.378 165.426 505.757 171.587C497.159 177.732 484.738 175.525 477.816 166.441C470.689 157.088 472.056 144.025 481.084 137.5C490.138 130.955 503.067 133.747 509.757 143.488Z",
    fill: "#EE85F5"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M510.678 179.665C500.367 187.033 486.255 186.223 475.942 178.328C493.273 167.718 503.228 149.588 507.635 129.7C511.126 132.03 514.262 135.081 516.754 138.782C526.087 152.688 523.192 170.756 510.678 179.665Z",
    fill: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M454.58 54.299C452.789 55.9856 401.728 56.8079 347.838 98.5527C346.868 99.299 345.798 97.7551 346.754 97.1435C377.839 73.0653 414.875 57.7203 453.862 52.7684C454.716 52.6608 455.199 53.7161 454.58 54.299Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.137 85.8039C424.561 97.3859 395.854 113.295 369.811 133.097C368.902 133.788 367.796 132.448 368.736 131.679C394.915 111.778 423.775 95.7819 454.511 84.1435C455.62 83.7209 456.231 85.4136 455.137 85.8039Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.658 132.043C429.961 142.358 405.295 155.435 382.352 170.91C381.944 171.185 381.393 171.075 381.119 170.671C380.847 170.264 380.954 169.72 381.358 169.435C404.405 153.889 429.184 140.755 454.998 130.396C455.452 130.211 455.97 130.434 456.15 130.889C456.334 131.342 456.113 131.864 455.658 132.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.202 168.393C516.358 157.565 511.703 141.782 498.951 137.153C497.84 136.751 498.462 135.08 499.552 135.481C513.404 140.505 518.512 157.667 509.616 169.464C509.368 169.822 507.473 169.36 508.202 168.393Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.152 176.056C446.081 176.122 446.001 176.179 445.909 176.218C432.494 182.259 420.156 190.327 409.24 200.197C408.308 201.038 407.17 199.528 408.049 198.878C419.104 188.882 431.594 180.713 445.179 174.598C445.627 174.396 446.153 174.596 446.352 175.042C446.511 175.398 446.42 175.803 446.152 176.056Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.438 120.126L489.704 115.968C489.247 114.87 490.89 114.204 491.344 115.281L493.078 119.44C493.526 120.524 491.895 121.212 491.438 120.126Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.175 119.295L496.634 114.454C496.734 113.287 498.512 113.446 498.399 114.622L497.941 119.462C497.828 120.639 496.063 120.461 496.175 119.295Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.146 120.925L502.541 117.042C502.941 115.932 504.607 116.542 504.21 117.644L502.815 121.527C502.423 122.631 500.747 122.034 501.146 120.925Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9461_5753",
    x1: 398.835,
    y1: 134.5,
    x2: -137.331,
    y2: 234.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAE2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBDDFC",
    stopOpacity: 0.28
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9461_5753",
    x1: 398.835,
    y1: 134.5,
    x2: -137.331,
    y2: 234.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAE2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBDDFC",
    stopOpacity: 0.28
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionOneNewBoxBg);
export default __webpack_public_path__ + "static/media/section-one-new-box-bg.6bf342b90144dc42b05472641ab3a5ef.svg";
export { ForwardRef as ReactComponent };